exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#Map .container{height:calc(100vh - 56px);width:100%;position:absolute;left:0;right:0;bottom:0}#Map .map{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/Map/style.scss
// module id = 1303
// module chunks = 0